"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBarChartOption = getBarChartOption;
exports.getChartData = getChartData;
exports.getFunnelChartData = getFunnelChartData;
exports.getFunnelChartOption = getFunnelChartOption;
exports.getLineChartOption = getLineChartOption;
exports.getMapChartData = getMapChartData;
exports.getMapChartOption = getMapChartOption;
exports.getPieChartData = getPieChartData;
exports.getPieChartOption = getPieChartOption;
exports.optionUpdate = void 0;
require("core-js/modules/es7.object.values");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.to-string");
var _index = require("./index");
/**
 * 判断参数类型方法
 */
var classof = function classof(o) {
  // Object.prototype.toString()返回"[object Object]",然后call(o)参数，返回该类型，如number类型call(1),返回"[object Number]",再使用slice(截取类型部分)
  return Object.prototype.toString.call(o).slice(8, -1);
};

/**
 * @description 数字千分位逗号   0 或者 空的参数返回 '-'
 * @param {Number} num 数字
 */
var getThousandNum = function getThousandNum(num) {
  return (Number(num) ? num : '-').toString().replace(/\d+/, function (n) {
    var len = n.length;
    if (len % 3 === 0) {
      return n.replace(/(\d{3})/g, ',$1').slice(1);
    } else {
      return n.slice(0, len % 3) + n.slice(len % 3).replace(/(\d{3})/g, ',$1');
    }
  });
};

/**
 * @description 小数转换成百分比，并带上百分号   0 或者 空的参数返回 '-'
 * @param {Number} smallNumber 小数
 */
var convertPercentForKeep = function convertPercentForKeep(smallNumber) {
  var str = smallNumber ? Number(100 * smallNumber).toFixed(2) : '-';
  str = str === 0 || str === '-' ? '-' : "".concat(str, "%");
  return str;
};
var optionUpdate = function optionUpdate(option, optionData) {
  // 初次拦截参数不为 object 的参数，返回默认设置好的参数
  if (classof(optionData) !== 'Object') {
    return option;
  }
  // 参数循环替换方法
  var optionFor = function optionFor(option, option_data) {
    // 判断是否为object 第一次进来必为object
    if (classof(option_data) === 'Object') {
      // 循环参数
      for (var item in option_data) {
        // 判断是否存在key 为item的参数
        if (option[item]) {
          // 存在 判断原始参数的key item的参数是否为 object 且不为数组  判断参数的key item的参数是否为 object 且不为数组
          if (classof(option[item]) === 'Object' && classof(option_data[item]) === 'Object') {
            // 是继续循环 object 去替换参数
            optionFor(option[item], option_data[item]);
          } else {
            // 否直接替换原始参数值为参数的值
            option[item] = option_data[item];
          }
        } else {
          // 不存在直接添加到原始参数里面
          option[item] = option_data[item];
        }
      }
    }
  };
  optionFor(option, optionData);
  return option;
};

// 折线图基础配置
exports.optionUpdate = optionUpdate;
var baseLineChartOptions = {
  xAxis: {
    axisTick: {
      show: false,
      type: 'shadow',
      alignWithLabel: true
    },
    boundaryGap: false
  },
  grid: {
    left: 10,
    right: 35,
    bottom: 20,
    top: 50,
    containLabel: true
  },
  tooltip: {
    trigger: 'axis',
    padding: [5, 10]
  },
  yAxis: {
    axisTick: {
      show: false
    }
  },
  legend: {},
  series: []
};

// 柱状图基础配置
var baseBarChartOptions = {
  xAxis: {
    axisTick: {
      show: false,
      type: 'shadow',
      alignWithLabel: true
    }
  },
  grid: {
    left: 10,
    right: 10,
    bottom: 20,
    top: 50,
    containLabel: true
  },
  tooltip: {
    trigger: 'axis',
    'axisPointer': {
      type: 'shadow'
    },
    padding: [5, 10]
  },
  yAxis: {
    axisTick: {
      show: false
    }
  },
  legend: {},
  series: []
};

// 中国地图基础配置
var baseMapChartOption = {
  tooltip: {
    show: true,
    formatter: function formatter(params) {
      return "".concat(params.name, "\uFF1A").concat(params.data ? params.data['value'] : 0);
    }
  },
  visualMap: {
    type: 'continuous',
    min: 0,
    max: 0,
    bottom: 20,
    left: 20,
    inRange: {
      color: ['#edfbfb', '#b7d6f3', '#40a9ed', '#3598c1', '#215096']
    },
    show: true
  },
  geo: {
    map: 'china',
    roam: true,
    layoutSize: '80%',
    label: {
      normal: {
        show: true,
        fontSize: '10',
        color: 'rgba(0,0,0,0.7)'
      }
    },
    itemStyle: {
      normal: {
        borderColor: 'rgba(0, 0, 0, 0.2)'
      },
      emphasis: {
        areaColor: '#ff6499',
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowBlur: 20,
        borderWidth: 0,
        shadowColor: 'rgba(0, 0, 0, 0.5)'
      }
    }
  },
  series: [{
    name: '信息量',
    type: 'map',
    geoIndex: 0
  }]
};

// 饼状图基础配置
var basePieChartOption = {
  tooltip: {
    trigger: 'item',
    textStyle: {
      fontSize: '10'
    },
    formatter: function formatter(b) {
      return "".concat(b.name).concat(b.data.scene ? ' (' + b.data.scene + ') ' : '', ": ").concat(getThousandNum(b.value), " (").concat(b.percent, "%)");
    }
  },
  legend: {
    orient: 'vertical',
    x: 'right',
    y: '20',
    data: [],
    textStyle: {
      fontSize: '10'
    }
  },
  series: [{
    type: 'pie',
    radius: ['50%', '70%'],
    data: [],
    animationEasing: 'cubicInOut',
    animationDuration: 2600
  }]
};

// 漏斗基础配置
var baseFunnelChartOption = {
  tooltip: {
    trigger: 'item',
    textStyle: {
      fontSize: '10'
    },
    formatter: '{b} : {c}%'
  },
  legend: {
    data: [],
    textStyle: {
      fontSize: '10'
    }
  },
  series: [{
    type: 'funnel',
    min: 0,
    max: 100,
    minSize: '0%',
    maxSize: '100%',
    emphasis: {
      label: {
        fontSize: 14
      }
    },
    sort: 'descending',
    label: {
      show: true,
      position: 'inside'
    },
    data: []
  }]
};
function getPieChartData(data, idKey, filedKey) {
  var dataList = [];
  var nameList = [];
  data.forEach(function (item) {
    if (parseInt(item[filedKey]) > 0) {
      dataList.push({
        'name': item[idKey],
        'scene': item['name'],
        'value': item[filedKey]
      });
      nameList.push(item[idKey]);
    }
  });
  return {
    dataList: dataList,
    nameList: nameList
  };
}
function getFunnelChartData(data, idKey, filedKey) {
  var dataList = [];
  var nameList = [];
  data.forEach(function (item) {
    dataList.push({
      'name': item[idKey],
      'value': (0, _index.toFix)(item[filedKey] * 100, 2)
    });
    nameList.push(item[idKey]);
  });
  return {
    dataList: dataList,
    nameList: nameList
  };
}
function getMapChartData(data, idKey, filedKeys) {
  var dataList = [];
  var maxValue = 0;
  data.forEach(function (item) {
    dataList.push({
      'name': item[idKey],
      'value': item[filedKeys]
    });
    if (item[filedKeys] > maxValue) maxValue = item[filedKeys];
  });
  return {
    dataList: dataList,
    maxValue: maxValue
  };
}
function getChartData(data, idKey, filedKeys) {
  var xAxis = [];
  var series = {};
  var legend = {};
  filedKeys.forEach(function (item) {
    legend[item['key']] = item['name'];
    series[item['key']] = [];
  });
  data.forEach(function (item) {
    xAxis.push(item[idKey]);
    for (var k in legend) {
      series[k].push(item[k]);
    }
  });
  return {
    'xAxis': xAxis,
    'legend': legend,
    'series': series
  };
}
function getLineChartOption(data, idKey, filedKeys) {
  var asc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (!asc) data = (0, _index.deepClone)(data).reverse();
  var _getChartData = getChartData(data, idKey, filedKeys),
    xAxis = _getChartData.xAxis,
    legend = _getChartData.legend,
    series = _getChartData.series;
  var options = (0, _index.deepClone)(baseLineChartOptions);
  options['xAxis']['data'] = xAxis;
  options['legend']['data'] = Object.values(legend);
  for (var key in series) {
    var item = series[key];
    options['series'].push({
      name: legend[key],
      smooth: true,
      type: 'line',
      data: item,
      animationDuration: 2800,
      animationEasing: 'cubicInOut',
      areaStyle: {}
    });
  }
  return options;
}
function getBarChartOption(data, idKey, filedKeys) {
  var asc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (!asc) data = (0, _index.deepClone)(data).reverse();
  var _getChartData2 = getChartData(data, idKey, filedKeys),
    xAxis = _getChartData2.xAxis,
    legend = _getChartData2.legend,
    series = _getChartData2.series;
  var options = (0, _index.deepClone)(baseBarChartOptions);
  options['xAxis']['data'] = xAxis;
  options['legend']['data'] = Object.values(legend);
  for (var key in series) {
    var item = series[key];
    options['series'].push({
      name: legend[key],
      smooth: true,
      type: 'bar',
      data: item,
      barWidth: '60%',
      animationDuration: 2800,
      animationEasing: 'cubicInOut'
    });
  }
  return options;
}
function getMapChartOption(data, idKey, filedKeys) {
  var _getMapChartData = getMapChartData(data, idKey, filedKeys),
    dataList = _getMapChartData.dataList,
    maxValue = _getMapChartData.maxValue;
  var options = (0, _index.deepClone)(baseMapChartOption);
  options['visualMap']['max'] = maxValue;
  options['series'][0]['data'] = dataList;
  return options;
}
function getPieChartOption(data, idKey, filedKeys) {
  var _getPieChartData = getPieChartData(data, idKey, filedKeys),
    dataList = _getPieChartData.dataList,
    nameList = _getPieChartData.nameList;
  var options = (0, _index.deepClone)(basePieChartOption);
  options['series'][0]['data'] = dataList;
  options['legend']['data'] = nameList;
  options['legend']['formatter'] = function (name) {
    // 格式化图例文本，自定义显示样式
    var total = 0;
    var value;
    dataList.forEach(function (item) {
      if (item.name === name) {
        value = item.value;
      }
      item.value = Number(item.value) > 0 ? Number(item.value) : 0;
      total += Number(item.value);
    });
    return "".concat(name, " : ").concat(getThousandNum(value), " (").concat(convertPercentForKeep(value / total), ")");
  };
  return options;
}
function getFunnelChartOption(data, idKey, filedKey) {
  var _getFunnelChartData = getFunnelChartData(data, idKey, filedKey),
    nameList = _getFunnelChartData.nameList,
    dataList = _getFunnelChartData.dataList;
  var options = (0, _index.deepClone)(baseFunnelChartOption);
  options['series'][0]['data'] = dataList;
  options['legend']['data'] = nameList;
  return options;
}